module.exports = __webpack_public_path__ + "media/icons/search-50bffb66.svg";